import React from 'react';
import HealthStatusIcon from '../../atoms/HealthStatusIcon/view';
import './style.css';

/**
 * ProviderStatus Molecule
 * A badge that displays the technological provider's health status.
 * @param {string} status - 'online', 'warning', 'down', 'loading'
 * @param {string} providerName - The name of the provider (default: 'Proveedor')
 * @param {function} onClick - Function to call when clicked (e.g., to show a breakdown)
 */
const ProviderStatus = ({ status = 'loading', providerName = 'Proveedor', onClick }) => {

    // Friendly status labels
    const statusLabels = {
        online: 'Online',
        warning: 'Inestable',
        down: 'Fuera de Línea',
        loading: 'Verificando...'
    };

    return (
        <div
            className={`provider-status-molecule ${status}`}
            onClick={onClick}
            title="Ver detalles del sistema"
            role="button"
            tabIndex={0}
        >
            <HealthStatusIcon status={status} />
            <div className="provider-status-label">
                <span className="provider-name">{providerName}</span>
                <span className="status-text">{statusLabels[status] || 'Cargando...'}</span>
            </div>
        </div>
    );
};

export default ProviderStatus;
